'use es6';

import AbLikeEmailCloneBody from 'EmailComponents/emailCreation/AbLikeEmailCloneBody';
import { DEFAULT_ACCOUNT_BUSINESS_UNIT_ID } from 'EmailComponents/utils/getBUFromLocalStorage';
import { EMAIL_TEMPLATE_MODE_MODAL_TYPES as MODAL_TYPES } from 'EmailData/constants/emailCreation';
import EmailTemplateModes from 'EmailData/enums/EmailTemplateModes';
import EmailType from 'EmailData/enums/EmailType';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFlex from 'UIComponents/layout/UIFlex';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import SelectableButtonWithDescription from './SelectableButtonWithDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EmailTemplateModeSelectModalBody extends Component {
  constructor(props) {
    super(props);
    this.onSelectBusinessUnit = buId => {
      if (buId && buId !== DEFAULT_ACCOUNT_BUSINESS_UNIT_ID) {
        this.setState({
          isBusinessUnitSelected: true,
          isAccountSelected: false
        });
      } else if (buId === DEFAULT_ACCOUNT_BUSINESS_UNIT_ID) {
        this.setState({
          isBusinessUnitSelected: false,
          isAccountSelected: true
        });
      } else {
        this.setState({
          isBusinessUnitSelected: false,
          isAccountSelected: false
        });
      }
      this.props.onSelectBusinessUnit(buId);
    };
    this.handleTextChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        cloneEmailName: value
      });
      this.props.onCloneEmailNameChange(value);
    };
    this.onClone = () => this.setState({
      shouldRenderEmailTemplateTypeSelectOption: true
    });
    this.isEmailEligibleForBUDropDown = () => {
      const {
        canAccessBusinessUnit,
        type,
        emailType
      } = this.props;
      const eligibleEmailForBusinessUnitClone = [EmailType.AB_EMAIL, EmailType.AUTOMATED_AB_EMAIL, EmailType.LOCALTIME_EMAIL, EmailType.SINGLE_SEND_API, EmailType.MARKETING_SINGLE_SEND_API, EmailType.LEADFLOW_EMAIL];
      return canAccessBusinessUnit && type === MODAL_TYPES.CLONE && eligibleEmailForBusinessUnitClone.includes(emailType);
    };
    this.overrideCloneOptions = (overrideABCloneOption, abCloneOptionsValue) => {
      this.setState({
        overrideABCloneOption
      });
      if (overrideABCloneOption) {
        this.props.onSelectVariant(abCloneOptionsValue);
      }
    };
    this.maybeRenderEmailTemplateTypeSelection = () => {
      const {
        onClickClassic,
        type,
        onClickDragDrop,
        selectedTemplateMode
      } = this.props;
      return /*#__PURE__*/_jsx("div", {
        "data-test-id": "email-template-type-selection",
        children: /*#__PURE__*/_jsx(UIFormControl, {
          label: this.maybeRenderSubtitle(),
          children: /*#__PURE__*/_jsxs(UIFlex, {
            direction: "column",
            align: "center",
            justify: "center",
            children: [/*#__PURE__*/_jsx(SelectableButtonWithDescription, {
              onClick: onClickDragDrop,
              buttonLabel: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: `EmailComponents.modals.creation.chooseEmailTemplateType.${type}.dragDrop.name`
              }),
              illustrationName: "text-snippet",
              isSelected: selectedTemplateMode === EmailTemplateModes.DRAG_AND_DROP,
              description: /*#__PURE__*/_jsxs(Fragment, {
                children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `EmailComponents.modals.creation.chooseEmailTemplateType.${type}.dragDrop.label`
                }), this.maybeRenderDragDropDetails()]
              })
            }), /*#__PURE__*/_jsx(SelectableButtonWithDescription, {
              onClick: onClickClassic,
              buttonLabel: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: `EmailComponents.modals.creation.chooseEmailTemplateType.${type}.classic.name`
              }),
              illustrationName: "email-browser",
              isSelected: selectedTemplateMode === EmailTemplateModes.DESIGN_MANAGER,
              description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: `EmailComponents.modals.creation.chooseEmailTemplateType.${type}.classic.label`
              })
            })]
          })
        })
      });
    };
    this.state = {
      cloneEmailName: this.getCloneName(this.props.emailName),
      isBusinessUnitSelected: false,
      isAccountSelected: false,
      canAccessBusinessUnit: props.canAccessBusinessUnit,
      shouldRenderEmailTemplateTypeSelectOption: !this.isEmailEligibleForBUDropDown() && (!this.props.content || this.props.content && !this.props.content.isABLike()),
      overrideABCloneOption: false
    };
  }
  static getDerivedStateFromProps(newProps, state) {
    const {
      canAccessBusinessUnit
    } = state;
    if (canAccessBusinessUnit && newProps.buOptions.length === 1) {
      return {
        isAccountSelected: true,
        canAccessBusinessUnit: newProps.canAccessBusinessUnit
      };
    }
    return {
      isAccountSelected: state.isAccountSelected,
      canAccessBusinessUnit: newProps.canAccessBusinessUnit
    };
  }
  getCloneName(emailName) {
    const suffix = I18n.text('EmailComponents.modals.clone.clonedContentSuffix');
    return `${emailName} ${suffix}`;
  }
  maybeRenderDragDropDetails() {
    const {
      previewDdUrl
    } = this.props;
    if (!previewDdUrl) {
      return null;
    }
    return /*#__PURE__*/_jsxs("small", {
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.modals.creation.chooseEmailTemplateType.clone.dragDrop.previewText",
        options: {
          url: previewDdUrl
        },
        onClick: e => e.stopPropagation()
      })]
    });
  }
  maybeRenderSubtitle() {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.modals.creation.chooseEmailTemplateType.templateType"
    });
  }
  render() {
    const {
      buOptions,
      content,
      emailBusinessUnitId,
      emailName,
      emailDetails,
      onCancel
    } = this.props;
    const {
      cloneEmailName,
      isAccountSelected,
      isBusinessUnitSelected,
      overrideABCloneOption,
      shouldRenderEmailTemplateTypeSelectOption
    } = this.state;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "email-template-mode-select-modal-body",
      children: shouldRenderEmailTemplateTypeSelectOption ? this.maybeRenderEmailTemplateTypeSelection() : /*#__PURE__*/_jsx(AbLikeEmailCloneBody, {
        buOptions: buOptions,
        content: content,
        emailBusinessUnitId: emailBusinessUnitId,
        emailName: emailName,
        emailDetails: emailDetails,
        onClone: this.onClone,
        onCancel: onCancel,
        onSelectBusinessUnit: this.onSelectBusinessUnit,
        handleTextChange: this.handleTextChange,
        isEmailEligibleForBUDropDown: this.isEmailEligibleForBUDropDown(),
        isBusinessUnitSelected: isBusinessUnitSelected,
        isAccountSelected: isAccountSelected,
        cloneEmailName: cloneEmailName,
        overrideABCloneOption: overrideABCloneOption,
        overrideCloneOptions: this.overrideCloneOptions
      })
    });
  }
}
EmailTemplateModeSelectModalBody.propTypes = {
  buOptions: PropTypes.array,
  canAccessBusinessUnit: PropTypes.bool.isRequired,
  content: PropTypes.object,
  emailBusinessUnitId: PropTypes.number,
  emailDetails: PropTypes.object,
  emailName: PropTypes.string,
  emailType: PropTypes.string,
  type: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onClickDragDrop: PropTypes.func,
  onClickClassic: PropTypes.func,
  onCloneEmailNameChange: PropTypes.func.isRequired,
  onSelectBusinessUnit: PropTypes.func.isRequired,
  onSelectVariant: PropTypes.func.isRequired,
  previewDdUrl: PropTypes.string,
  selectedTemplateMode: PropTypes.string
};
EmailTemplateModeSelectModalBody.defaultProps = {
  buOptions: [],
  type: MODAL_TYPES.CREATE
};
export default EmailTemplateModeSelectModalBody;